import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e136684"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e136684')) {
      api.createRecord('5e136684', component.options)
    } else {
      api.reload('5e136684', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5e136684", function () {
      api.rerender('5e136684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Enabled/index.vue"
export default component.exports